import { Dimensions, Platform } from 'react-native'

const { height, width } = Dimensions.get('window');

const sectionSeparation = height * 0.015;
const circleDimension = width * 0.08;
const adCardsDeimension = Platform.OS === 'web' && width > 700 ? ((width - 30) / 2) * 0.1 : circleDimension
const multiplelineSeparation = height * 0.01;
const lineHeight = height * 0.017;
const lineStyle = {
  height: lineHeight,
  borderRadius: 0,
};

const dimensions = {
  mainCard: [
    {
      circle: circleDimension,
      lineOne: width * 0.4,
      lineTwo: width * 0.2,
    },
    {
      line: '100%',
    },
    {
      line: '40%',
    },
  ],
  secCard: [
    {
      circle: circleDimension,
      line: '60%',
    },
    {
      line: '100%',
    },
  ],
  adCards: [
    {
      circle: adCardsDeimension,
      line: '50%',
    },
    {
      line: '100%',
    },
  ],
  lastUpdated: [
    {
      line: '100%',
    },
  ],
};

const styles = {
  mainCard: [
    {
      circle: { marginRight: width * 0.03 },
      lineOne: { marginBottom: 0, ...lineStyle },
      lineTwo: { marginBottom: 0, ...lineStyle },
      style: {
        marginBottom: sectionSeparation,
      },
    },
    {
      line: { marginBottom: multiplelineSeparation, ...lineStyle },
      style: {
        marginBottom: sectionSeparation - multiplelineSeparation,
      },
    },
    {
      line: { ...lineStyle },
    },
  ],
  secCard: [
    {
      circle: { marginRight: width * 0.03 },
      line: { marginBottom: 0, ...lineStyle },
      style: {
        marginBottom: sectionSeparation,
      },
    },
    {
      line: { marginBottom: multiplelineSeparation, ...lineStyle },
    },
  ],
  adCards: [
    {
      circle: { marginRight: width * 0.03 },
      line: { marginBottom: 0, ...lineStyle },
      style: {
        marginBottom: sectionSeparation,
      },
    },
    {
      line: { ...lineStyle },
    },
  ],
  lastUpdated: [
    {
      line: { marginBottom: 0, ...lineStyle },
    },
  ],
};

export { dimensions, styles, circleDimension, lineStyle, height, multiplelineSeparation, width };
